const Home = () => import("../components/homeView.vue");


/* Exporting the object routes of home module. */
export default [
  {
    name: "home",
    path: "/home",
    meta: {
      Title: "Home",
      layout: "LoggedLayout",
      requireAuth: true
    },
    component: Home,
  },
];